import { Component, ViewChild, AfterViewInit } from "@angular/core";
import { BrowserStorage } from "./core/storage";
import { ThemeService } from "./services/theme.service";
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet } from "@angular/router";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  standalone: false,
})
export class AppComponent implements AfterViewInit {
  title = "Cristie License Portal";

  @ViewChild("outlet", { static: true }) outlet: RouterOutlet;

  loading = true;

  constructor(
    private router: Router,
    private ts: ThemeService,
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.loading = true;
      }

      if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
        this.loading = false;
        setTimeout(() => this.applyAutomationIds());
      }
    });
  }

  ngAfterViewInit(): void {
    const theme = BrowserStorage.getString("theme", false) || BrowserStorage.getString("theme");
    this.ts.setTheme(theme == null ? "midnight" : theme);
    if (theme == null) BrowserStorage.setString("theme", "midnight", false);
    this.applyAutomationIds();
  }

  private applyAutomationIds(): void {
    const routeKey =
      (this.router.url || "root")
        .replace(/[^a-z0-9]+/gi, "-")
        .replace(/^-|-$/g, "")
        .toLowerCase() || "root";
    const seen = new Map<string, number>();
    const selector = "button, input, select, textarea, a, form, table, summary, details, [mat-menu-item], [matinput]";

    document.querySelectorAll<HTMLElement>(selector).forEach((element) => {
      if (element.id) return;

      const parts = [
        element.getAttribute("formcontrolname"),
        element.getAttribute("name"),
        element.getAttribute("routerlink"),
        element.getAttribute("href"),
        element.getAttribute("placeholder"),
        element.getAttribute("type"),
        element.getAttribute("aria-label"),
        (element.textContent || "")
          .trim()
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, "-"),
      ].filter(Boolean);

      const base = parts.length ? (parts[0] as string) : element.tagName.toLowerCase();
      const slug =
        String(base)
          .replace(/[^a-z0-9]+/gi, "-")
          .replace(/^-|-$/g, "")
          .toLowerCase() || element.tagName.toLowerCase();
      const key = `${routeKey}-${slug}`;
      const count = (seen.get(key) || 0) + 1;
      seen.set(key, count);
      element.id = count === 1 ? key : `${key}-${count}`;
    });
  }
}
